module.exports = __webpack_public_path__ + "static/media/texture-brown.9dc8dbb4.png";